export default Object.freeze({
  FULL_TEXT_PDF: 'FULL_TEXT_PDF',
  REFERENCE_RIS: 'REFERENCE_RIS',
  REFERENCE_END_NOTE: 'REFERENCE_END_NOTE',
  END_NOTE_DIRECTORY: 'END_NOTE_DIRECTORY',
});
